import { styled } from '@mui/material/styles';

export const StyHomeFiltersWrapper = styled('div', {
    name: 'StyHomeFiltersWrapper',
})({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    '&:nth-of-type(2)': {
        marginTop: '1rem',
        flexWrap: 'wrap',
        gap: '2rem',
    },
});

export const StyHomeFilters = styled('div', {
    name: 'StyHomeFilters',
})({
    maxWidth: '100%',
});

export const StyFilters = styled('div', {
    name: 'StyFilters',
})({
    maxWidth: '100%',
    display: 'flex',
    gap: '2rem',
    alignItems: 'flex-start',
    flexWrap: 'nowrap',
    flexShrink: '0',
    '& > *': {
        margin: 'auto 0',
    },
});
